import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { Box, Grid, Typography, Table, TableBody, TableContainer, TableRow, TableHead, Paper, TableCell, Button } from '@mui/material';
import { getBiocharProduction } from '../../../../actions/tigercat-burns/tigercat-dashboard-actions';
import { BarChart, Bar, XAxis, YAxis, Tooltip, Legend, ResponsiveContainer, CartesianGrid } from "recharts";

export const BiocharProduction = ({ activeCarRppbProject, scrollId }) => {

    const dispatch = useDispatch()
    const [alternativeLayout, setAlternativeLayout] = useState(false)
    const biocharProduction = useSelector(state => state.tigercatBurnsDashboardReducer.biocharProduction).biocharProductionData
    useEffect(() => {
        if (activeCarRppbProject) {
            dispatch(getBiocharProduction(activeCarRppbProject.id))
        }
    }, [dispatch, activeCarRppbProject])
    const formattedData = biocharProduction?.mbIdWetMasses.map((item) => ({
        ...item,
        avgMoistureContent: item.avgMoistureContent ?? 0,
    }));

    return (
        <>
            {activeCarRppbProject &&
                <Grid container>
                    <Grid item md={12} >
                        <Button size="small" variant='contained' sx={{ backgroundColor: 'grey', height: 'auto', float: 'right', mt: 1, mb: 1, mr: 5 }} onClick={() => setAlternativeLayout(!alternativeLayout)}>Change Layout</Button>
                    </Grid>
                    <Grid item md={alternativeLayout ? 6 : 4} >
                        {/* <Grid item sm={12} > */}
                        {/* </Grid> */}
                        {/* ITERATE OVER NOTE LOGS HERE */}
                        {/* {[0, 1, 2, 3, 4, 5].map((v, i) => { */}
                        <Typography variant='h5' component='h4' sx={{ mb: 2.5 }} id={scrollId}>
                            Biochar Production Summary
                        </Typography>
                        <Box sx={{ display: 'flex', alignItems: 'start', flexDirection: 'column', }} >
                            <TableContainer component={Paper} sx={{ height: 'auto' }}>
                                <Table aria-label="simple table">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell align="left">
                                                Measured From
                                            </TableCell>
                                            <TableCell align="left">
                                                Total Wet Mass
                                            </TableCell>
                                            <TableCell align="left">
                                                Average MC
                                            </TableCell>
                                            <TableCell align="left">
                                                Total Dry Mass
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        <TableRow >
                                            <TableCell align="left">
                                                Bagged Biochar
                                            </TableCell>
                                            <TableCell align="left">
                                                {biocharProduction?.totalWetMass?.toFixed(2)}
                                            </TableCell>
                                            <TableCell align="left">
                                                {biocharProduction?.avgMoistureContent?.toFixed(2)}
                                            </TableCell>
                                            <TableCell align="left">
                                                {biocharProduction?.totalDryMass?.toFixed(2)}
                                            </TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Box>
                        <Typography variant='h5' component='h4' sx={{ mb: 2.5, mt: 2.5 }} id={scrollId}>
                            Bag Summary
                        </Typography>
                        <Box sx={{ display: 'flex', alignItems: 'start', flexDirection: 'column', }} >
                            <TableContainer component={Paper} sx={{ height: 'auto' }}>
                                <Table aria-label="simple table">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell align="left">
                                                Total Bags Bagged in Project
                                            </TableCell>
                                            <TableCell align="left">
                                                Average Bag Mass (wet)
                                            </TableCell>
                                            <TableCell align="left">
                                                Total Bags Loaded/Collected
                                            </TableCell>
                                            <TableCell align="left">
                                                Bag Inventory
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        <TableRow >
                                            <TableCell align="left">
                                                {biocharProduction?.totalBagsInProject}
                                            </TableCell>
                                            <TableCell align="left">
                                                {biocharProduction?.averageBagMass?.toFixed(2)}
                                            </TableCell>
                                            <TableCell align="left">
                                                {biocharProduction?.totalBagsLoaded}
                                            </TableCell>
                                            <TableCell align="left">
                                                {biocharProduction?.bagInventory}
                                            </TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Box>
                    </Grid>
                    <Grid item md={alternativeLayout ? 12 : 8} sx={{ padding: alternativeLayout ? 6 : 2 }} >
                        {biocharProduction && biocharProduction?.totalWetMass !== 0 && <ResponsiveContainer width="100%" height={500}>
                            <BarChart data={formattedData} margin={{ top: 50, right: 30, left: 30, bottom: 10, padding: 2 }}>
                                <text
                                    x="50%" // Center horizontally
                                    y={25} // Position vertically
                                    textAnchor="middle" // Align text to the center
                                    dominantBaseline="middle"
                                    style={{ fontSize: '26px' }}
                                >
                                    Total Wet Mass & Moisture Content of Biochar Bags
                                </text>
                                <CartesianGrid strokeDasharray="3 3" />
                                <XAxis dataKey="tc_batch__mb_id" label={{ value: "MB ID", position: "insideBottom", dy: 15 }} />
                                <YAxis yAxisId="left" label={{ value: "Total Wet Mass", angle: -90, position: "insideLeft", dy: 55, dx: -20 }} />
                                <YAxis yAxisId="right" orientation="right" label={{ value: "Moisture Content", angle: -90, position: "insideRight", dy: -65, dx: -10 }} />
                                <Tooltip />
                                <Legend wrapperStyle={{ marginBottom: -10, marginLeft: '0' }} />

                                <Bar yAxisId="left" dataKey="totalWetMass" fill="#3A9D9B " barSize={50} name="Total Wet Mass" animationDuration={1700} />
                                <Bar yAxisId="right" dataKey="avgMoistureContent" fill="#3F5EAB" barSize={50} name="Moisture Content" animationDuration={1700} />
                            </BarChart>
                        </ResponsiveContainer>}
                    </Grid>
                </Grid>
            }
        </>
    )
}